import React from 'react';

import type { DepositRegistration } from '@/types/database/depositRegistration';

import CheckDetailAndRobotDeliveryButtons from './components/CheckDetailAndRobotDeliveryButtons';
import DepositInfo from './components/DepositInfo';
import TimeAndStatus from './components/TimeAndStatus';
import { showNoDataText } from './helpers';
import styles from './index.module.scss';

type DepositListProps = {
  depositList: DepositRegistration[];
  tab: number;
};

const DepositList = ({ depositList, tab }: DepositListProps) => {
  const noDataText = showNoDataText(tab);

  return (
    <div className={styles.list}>
      {depositList.length === 0 ? (
        <p className={styles.noData}>{noDataText}</p>
      ) : (
        depositList.map((deposit, index) => {
          return (
            <div className={styles.item} key={index}>
              <div className={styles.infoSection}>
                <TimeAndStatus
                  createdTime={deposit.createdTime}
                  status={deposit.status}
                />
                <DepositInfo deposit={deposit} />
              </div>
              <CheckDetailAndRobotDeliveryButtons deposit={deposit} />
            </div>
          );
        })
      )}
    </div>
  );
};

export default DepositList;
